import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'limitTo',
    standalone: false
})
export class LimitToPipe implements PipeTransform {

  transform(value: any, limit: number): any {
    return 1;
  }

}
